import classNames from "classnames/bind";
import React, { useCallback, useState } from "react";
import { Skeleton } from "../Skeleton";
import { Step } from "./Step";
import { getStepState } from "./Stepper.helpers";
import styles from "./Stepper.module.scss";
import type { StepperProps } from "./types";

const cx = classNames.bind(styles);

/**
 * A component to indicate to a user what step they are on in a multi-step process
 */
const Stepper = ({
  steps,
  activeStep,
  onClickNode,
  orientation = "horizontal",
  isLoading = false,
  className,
  isFluid = false,
  style,
}: StepperProps) => {
  const [listRef, setListRef] = useState<HTMLUListElement>();

  const onRefChange = useCallback(
    (node) => {
      setListRef(node);
    },
    [steps]
  );

  return (
    <Skeleton isLoading={isLoading}>
      <ul
        className={cx("container", orientation, className)}
        ref={onRefChange}
        style={style}
      >
        {steps.map((props, index) => (
          <Step
            key={steps[index]?.label}
            {...props}
            stepNumber={index + 1}
            state={getStepState({ activeStep, index })}
            isLast={index === steps.length - 1}
            orientation={orientation}
            listRef={listRef}
            isFluid={isFluid}
            {...(onClickNode ? { onClick: onClickNode } : {})}
          />
        ))}
      </ul>
    </Skeleton>
  );
};

export default Stepper;
